import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface PastDueBannerProps {
  onPay: () => void;
  paying?: boolean;
}

const PastDueBanner = ({ onPay, paying = false }: PastDueBannerProps) => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="past-due-banner"
      className="bg-red-600 text-white px-4 py-2.5 flex items-center justify-between gap-3 text-sm"
    >
      <span className="font-semibold">{t('billing.pastDueBanner')}</span>
      <Button
        size="sm"
        className="bg-white text-red-600 hover:bg-red-50 shrink-0 font-semibold"
        onClick={onPay}
        disabled={paying}
      >
        {paying ? t('billing.paying') : t('billing.payNow')}
      </Button>
    </div>
  );
};

export default PastDueBanner;
